(function () {
  function initVeraHomepage(root) {
    if (!root || root.dataset.veraHomepageInitialized === 'true') return;
    root.dataset.veraHomepageInitialized = 'true';

    var cols = root.querySelectorAll('.footer-col');

    function syncFooterColumns() {
      var isMobile = window.matchMedia('(max-width: 768px)').matches;
      cols.forEach(function (col) {
        col.open = !isMobile;
      });
    }

    syncFooterColumns();

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(syncFooterColumns, 150);
    });
  }

  function initializeAll() {
    document.querySelectorAll('#vera-homepage').forEach(initVeraHomepage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('#vera-homepage');
    if (root) initVeraHomepage(root);
  });
})();